import { render, staticRenderFns } from "./ConfigurationBankAccountsCard.vue?vue&type=template&id=71115dde&scoped=true&"
import script from "./ConfigurationBankAccountsCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationBankAccountsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71115dde",
  null
  
)

export default component.exports